import { render, staticRenderFns } from "./AboutUspage.vue?vue&type=template&id=a64696d4&scoped=true&"
import script from "./AboutUspage.vue?vue&type=script&lang=js&"
export * from "./AboutUspage.vue?vue&type=script&lang=js&"
import style0 from "./AboutUspage.vue?vue&type=style&index=0&id=a64696d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64696d4",
  null
  
)

export default component.exports